module.exports = __webpack_public_path__ + "img/service_actived.625fe7ec.png";